(ns manatee.auth.app-db
  "App. DB for login form.")

;; Data Paths

(def root-path
  [:login-form])

(def login-payload-path
  (conj root-path :login-payload))

(def login-email-path
  (conj login-payload-path :email))

(def login-password-path
  (conj login-payload-path :password))

(def email-dirty?-path
  (conj root-path :email-dirty?))

(def password-dirty?-path
  (conj root-path :password-dirty?))

;; Login Form

(defn clear-login-form
  [db]
  (dissoc db root-path))

;; Login Form Payload

(defn get-login-payload
  [db]
  (get-in db login-payload-path))

;; Email Field Data

(defn set-login-email
  [db login-email]
  (assoc-in db login-email-path login-email))

(defn email-dirty?
  [db]
  (get-in db email-dirty?-path))

(defn set-email-dirty
  [db v]
  (assoc-in db email-dirty?-path v))

;; Password Field Data

(defn set-login-password
  [db login-password]
  (assoc-in db login-password-path login-password))

(defn password-dirty?
  [db]
  (get-in db password-dirty?-path))

(defn set-password-dirty
  [db v]
  (assoc-in db password-dirty?-path v))
